import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';

const LocationSelectorMenuItem = (props) => {
  const {
    children,
    onClick,
    onMouseDown,
    onMouseMove,
    id,
    ariaLabel,
    customAccessibility,
    useInput,
    enabledAccessibilityLabel
  } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  let newAriaLabel = useInput ? ariaLabel : null;
  if (enabledAccessibilityLabel) {
    newAriaLabel = ariaLabel;
  }
  return (
    <Box
      className={`${className} location-selector-menu-item`}
      dataTestId="locationSelectorMenuItem"
      style={style}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      id={id}
      ariaLabel={newAriaLabel}
      role={useInput ? (customAccessibility ? 'application' : null) : null}
    >
      {children}
    </Box>
  );
};

LocationSelectorMenuItem.propTypes = {
  /**
   * Text of the item.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Id of item.
   */
  id: PropTypes.string,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func,
  ariaLabel: PropTypes.string,
  customAccessibility: PropTypes.bool
};

LocationSelectorMenuItem.defaultProps = {
  children: null,
  id: '',
  onClick: () => {},
  onMouseDown: () => {},
  onMouseMove: () => {},
  ariaLabel: 'ariaLabel',
  customAccessibility: false
};

export default LocationSelectorMenuItem;
